module.exports = __webpack_public_path__ + "static/media/3playerRoomsPlayed_2000_3000.eedb8f18.png";